import { Platform } from 'react-native';

export default {
  apiBaseUrl: 'https://playbook-api.qhlth.com/api/',
  socketUrl: 'https://playbook-api.qhlth.com/',
  webUrl: 'https://playbook.qhlth.com/',
  accessTokenKey: 'Authorization',
  bearerPrefix: 'bearer',
  expires: 365,
  secure: false,
  nutritionixAppId: '94e4784e',
  nutritionixAppKey: '06b5b7dd2280bfd224041a02ac9b740f',
  withingsClientId:
    'ce6f499a15768464925837c758d215f906cc1f25ea9e44c5f81ee3d680ab8992',
  withingsRedirectUrl: 'https://playbook-api.qhlth.com/api/withings/callback',
  fitbitAppClientId: '23QQXZ',
  fitbitRedirectWebUri: 'https://localhost:19006/*',
  fitbitRedirectAppUri: 'com.qhlth.production.playbook://home',
  privacyPolicyUrl: 'https://playbookapp.io/privacy-policy',
  termsOfServiceUrl: 'https://playbookapp.io/terms-of-use',
  hideInsurance: true,
  theme: {
    logo: require('../assets/environment/playbook/magnus-method/magnus-method-logo-black.png'),
    icon: require('../assets/environment/playbook/coach/coach-icon.png'),
    iconWhite: require('../assets/environment/playbook/magnus-method/magnus-method-icon-white.png'),
    organizationName: 'Playbook',
    appName: 'Coach',
    placeHolder: require('../assets/environment/playbook/working-out.png'),
    colors: {
      primary: '#2D2D2C',
      primaryDark: '#2D2D2C',
      primaryLight: '#ebecfb',
      primaryOutlineRestingBorder: '#2D2D2C',
      secondary: '#000',
      link: '#2D2D2C'
    }
  },
  loginAgreements: {
    termsOfService: 'https://playbookapp.io/terms-of-use',
    privacyPolicy: 'https://playbookapp.io/privacy-policy'
  },
  localizationPatches: {
    en: () => {
      return import('../locales/en.playbook.json');
    },
    es: () => {
      return import('../locales/es.playbook.json');
    }
  },
  navigation: {
    careTeam: false
  },
  screens: {
    medicationDetails: {
      class: false,
      prescriptionRefillReminder: false,
      informationAndInteractionCards: false
    }
  },
  supportEmail: 'evan@playbookcoach.io',
  videoCallProvider: 'zoom',
  zoomAppGroupId: 'com.qhlth.production.playbook',
};
